import { deepMerge } from '../utils';
const mapperCropValues = new Map([
    ['fill', 'fill'],
    ['scale', 'scale'],
    ['limit_pad', 'lpad'],
    ['fit', 'fit'],
    ['limit', 'lfit'],
    ['pad', 'pad'],
]);
export const mapCropTransformation = ({ crop, background, }) => {
    if (!crop) {
        return undefined;
    }
    const dhCrop = mapperCropValues.get(crop);
    if (!dhCrop) {
        return undefined;
    }
    return { resize: { mode: dhCrop, ...(background && { bg: background }) } };
};
export const mapResizeTransformation = ({ resize }) => {
    if (!resize) {
        return undefined;
    }
    const { height, width } = resize;
    return {
        resize: {
            ...(width && { width }),
            ...(height && { height }),
        },
    };
};
export const mapResizeCropTransformation = (transformation) => {
    const resizeDh = mapResizeTransformation(transformation);
    const cropDh = mapCropTransformation(transformation);
    if (!resizeDh) {
        return cropDh;
    }
    else if (!cropDh) {
        return resizeDh;
    }
    return deepMerge(cropDh, resizeDh);
};
//# sourceMappingURL=resize-crop.js.map